<div class="tree-selector-container">
  @if (personCount !== undefined) {
    <div class="profile-count">
      {{ 'treeSelector.profiles' | t }} <strong>{{ personCount }}</strong>
    </div>
  }
</div>
